import React from "react";
import { connect } from "react-redux";
import "../Forms/css/register.css";
import axios from "axios";

const token = localStorage.getItem('authToken');

class AddCoupons extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      title: '',
      code: '',
      user_limit: '', // Changed from `limit_for_user` to `user_limit`
      discount_type: 'amount',
      discount_amount: '',
      minimum_purchase: '',
      start_date: '',
      expiry_date: '', // Changed from `expire_date` to `expiry_date`
      submissionStatus: null,
    };
  }

  handleChange = (e) => {
    const { name, value } = e.target;
    this.setState({ [name]: value });
  };
  handleSubmit = async (e) => {
    e.preventDefault();
    const { title, code, user_limit, discount_type, discount_amount, minimum_purchase, start_date, expiry_date } = this.state;
  
    try {
      const response = await axios.post(
        "https://brand.aasmo.in/api/superadmin/coupons",
        {
          title,
          code,
          user_limit: Number(user_limit),
          discount_type,
          discount_amount: Number(discount_amount),
          minimum_purchase: Number(minimum_purchase),
          start_date: new Date(start_date).toISOString(), // Ensure proper date format
          expiry_date: new Date(expiry_date).toISOString() // Ensure proper date format
        },
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        }
      );
  
      if (response && response.status === 201) {
        this.setState({ submissionStatus: 'success' });
        console.log('Coupon added successfully');
        setTimeout(() => {
          window.location.href = "/list-coupons";
        }, 2000);
      } else {
        console.log('Unexpected response:', response);
      }
    } catch (error) {
      console.error('Error submitting form:', error);
      if (error.response) {
        const { status, data } = error.response;
        if (status === 400) {
          console.error('Bad request error:', data);
        } else if (status === 401) {
          console.error('Unauthorized error, please log in again.');
        } else {
          console.error('Error response:', error.response);
        }
      } else {
        console.error('Network or other error:', error);
      }
    }
  };
  
  

  render() {
    const { submissionStatus } = this.state;
    return (
      <div className="col-md-12">
        <form onSubmit={this.handleSubmit}>
          <div className="card">
            <div className="header">
              <h2>Add Coupon</h2>
            </div>
            <div className="card-body">
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group">
                    <label>Title</label>
                    <input
                      type="text"
                      className="form-control"
                      name="title"
                      value={this.state.title}
                      onChange={this.handleChange}
                      placeholder="Title"
                    />
                  </div>
                  <div className="form-group">
                    <label>Code</label>
                    <input
                      type="text"
                      className="form-control"
                      name="code"
                      value={this.state.code}
                      onChange={this.handleChange}
                      placeholder="Code"
                    />
                  </div>
                  <div className="form-group">
                    <label>User Limit</label>
                    <input
                      type="number"
                      className="form-control"
                      name="user_limit" // Ensure this matches your API field
                      value={this.state.user_limit}
                      onChange={this.handleChange}
                      placeholder="User Limit"
                    />
                  </div>
                  <div className="form-group">
                    <label>Start Date</label>
                    <input
                      type="datetime-local"
                      className="form-control"
                      name="start_date"
                      value={this.state.start_date}
                      onChange={this.handleChange}
                      placeholder="Start Date"
                    />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label>Discount Type</label>
                    <select
                      className="form-control"
                      name="discount_type"
                      value={this.state.discount_type}
                      onChange={this.handleChange}
                    >
                      <option value="amount">Amount</option>
                      <option value="percentage">Percentage</option>
                    </select>
                  </div>
                  <div className="form-group">
                    <label>Discount Amount</label>
                    <input
                      type="number"
                      className="form-control"
                      name="discount_amount"
                      value={this.state.discount_amount}
                      onChange={this.handleChange}
                      placeholder="Discount Amount"
                    />
                  </div>
                  <div className="form-group">
                    <label>Minimum Purchase</label>
                    <input
                      type="number"
                      className="form-control"
                      name="minimum_purchase"
                      value={this.state.minimum_purchase}
                      onChange={this.handleChange}
                      placeholder="Minimum Purchase"
                    />
                  </div>
                  <div className="form-group">
                    <label>Expiry Date</label>
                    <input
                      type="datetime-local"
                      className="form-control"
                      name="expiry_date" // Ensure this matches your API field
                      value={this.state.expiry_date}
                      onChange={this.handleChange}
                      placeholder="Expiry Date"
                    />
                  </div>
                </div>
              </div>
              {submissionStatus === 'success' && (
                <div className="alert alert-success" role="alert">
                  Coupon added successfully!
                </div>
              )}
              <button type="submit" className="btn btn-primary">
                Submit
              </button>
            </div>
          </div>
        </form>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({});

export default connect(mapStateToProps, {})(AddCoupons);
